jQuery(document).ready(function($) {
  function loadMoreProduct() {
    var $button = $('.load-more__btn');
    var $snipper = $('.load-more__snipper');
    var $productGrid = $('#product-grid');
    var currentPage = parseInt($productGrid.data('current-page'));
    var totalPages = parseInt($productGrid.data('pages'));
    var nextUrl = $productGrid.data('next-url');
    var $currentCount = $('.current-products-count');
    var totalProducts = parseInt($('.total-products-count').text());

    if (currentPage >= totalPages) {
      $button.hide();
      return;
    }

    $button.hide();
    $snipper.show();

    $.ajax({
      url: nextUrl,
      type: 'GET',
      success: function(data) {
        var $newProducts = $(data).find('#product-grid .grid__item');
        $productGrid.append($newProducts);

        currentPage += 1;
        $productGrid.data('current-page', currentPage);

        // Update next URL
        var nextUrl = $(data).find('#product-grid').data('next-url');
        $productGrid.data('next-url', nextUrl);

        // Update current products count
        var currentProductsCount = $productGrid.find('.grid__item').length;
        $currentCount.text(currentProductsCount);

        if (currentPage >= totalPages) {
          $button.hide();
        } else {
          $button.show();
        }

        $snipper.hide();
      },
      error: function(xhr, status, error) {
        $button.show();
        $snipper.hide();
      }
    });
  }

  $('.load-more__btn').on('click', function(e) {
    e.preventDefault();
    loadMoreProduct();
  });
});
